import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_SALES_ARGUMENT } from "../sales-argument.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateSalesArgumentInput } from "../../../__generated__/globalTypes";
import {
  CreateSalesArgumentMutation,
  CreateSalesArgumentMutationVariables,
} from "../../../__generated__/CreateSalesArgumentMutation";

interface IProps {
  defaultValues: DeepPartial<CreateSalesArgumentInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateSalesArgument = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateSalesArgumentInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateSalesArgumentMutation,
    CreateSalesArgumentMutationVariables
  >(CREATE_SALES_ARGUMENT, {
    refetchQueries: ["SalesArgumentsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createSalesArgument?.ok) {
        onCompleted(data.createSalesArgument.id);
      } else {
        throw Error(data?.createSalesArgument?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
